// extracted by mini-css-extract-plugin
module.exports = {"recording":"recording___LzJNI","icon":"icon___Zv_e_","title":"title___3dAgd","disable":"disable___3Quln","modalWrapper":"modalWrapper___28BvX"};